// 引入axios
import axios from "axios";

export const safeLog = {
  info: (message, data = {}) => {
    if (process.env.NODE_ENV === "development") {
      console.log(`[INFO] ${message}`, data);
    }
  },
  warn: (message, data = {}) => {
    if (process.env.NODE_ENV === "development") {
      console.warn(`[WARN] ${message}`, data);
    }
  },
  error: (message, data = {}) => {
    console.error(`[ERROR] ${message}`, data);
  },
};

// 获取当前域名或IP
const getCurrentBaseUrl = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const port = window.location.port;

  if (hostname === "www.magpies.top" || hostname === "magpies.top") {
    return `${protocol}//${hostname}`;
  }
  if (hostname === "192.168.0.147") {
    // 测试地址
    return "http://" + hostname + ":8000";
  }
  if (hostname === "39.98.33.187") {
    // 飞猪云服务器
    return "http://" + hostname + ":80";
  }
  if (hostname === "8.145.41.212") {
    // 阿里云服务器
    return "http://" + hostname + ":80";
  }
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://" + hostname + ":8000";
  }
  return "http://" + hostname + (port ? `:${port}` : "");
};
// let baseUrl = "http://192.168.0.147:8000/";
// let baseUrl = "http://39.98.33.187:80/"; // 飞猪
// let baseUrl = getCurrentBaseUrl();
// 创建axios实例
const httpService = axios.create({
  // url前缀-'http:xxx.xxx'
  // baseURL: process.env.BASE_API, // 需自定义
  baseURL: getCurrentBaseUrl(),
  // 请求超时时间
  timeout: 30000, // 需自定义
  withCredentials: true, // 允许携带 Cookie
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// 从 Cookie 中获取 CSRF 令牌
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

// CSRF Token 管理
// 移除预获取，完全按需获取
let csrfToken = null;

// 改进的fetchCsrfToken函数
export const fetchCsrfToken = async () => {
  // 如果已经有token，直接返回
  if (csrfToken) {
    return csrfToken;
  }

  try {
    // 首先尝试从cookie获取
    const cookieToken = getCookie("csrftoken");
    if (cookieToken) {
      csrfToken = cookieToken;
      safeLog.info("CSRF Token found in cookie");
      return csrfToken;
    }

    // 如果cookie中没有，从API获取
    const response = await httpService.get("/user/getCsrfToken/");
    if (response.data && response.data.csrfToken) {
      csrfToken = response.data.csrfToken;
      // 存储到cookie以备后续使用
      document.cookie = `csrftoken=${csrfToken}; Path=/; SameSite=Lax`;
      safeLog.info("CSRF Token fetched from API");
      return csrfToken;
    }

    throw new Error("Failed to get CSRF token");
  } catch (error) {
    safeLog.error("Error fetching CSRF token:", error);
    throw error;
  }
};

// 设置CSRF token的函数
export const setCsrfToken = (token) => {
  csrfToken = token;
  safeLog.info("CSRF Token set manually");
};

//添加请求和响应拦截器
// 添加请求拦截器
httpService.interceptors.request.use(
  async function (config) {
    if (config.url === "/user/login" || config.url.includes("/user/login")) {
      // 确保有CSRF token和Cookie
      if (!csrfToken) {
        try {
          await fetchCsrfToken();
        } catch (error) {
          safeLog.error("Failed to get CSRF token for login", error);
          return Promise.reject(error);
        }
      }

      // 同时设置请求头和确保Cookie存在
      config.headers["X-CSRFToken"] = csrfToken;
      config.withCredentials = true; // 确保发送Cookie
      return config;
    }
    // 排除获取CSRF token的请求本身和不需要认证的请求
    const noAuthUrls = [
      "/user/captcha",
      "/user/getCsrfToken/",
      "/tc/SearchZZXQTC",
      "/tc/VerifyZZXQTC",
      "/tc/OrderZZXQTC",
      "/fz/queryTaobao",
      "/fz/priceVerifyTaobao",
      "/fz/orderTaobao",
      "/fz/orderCancelTaobao",
      "/fz/order",
      "/fz/paymentVerifyTaobao",
      "/productManagement/recordFlightChangeNotification",
      "/qunar/queryQunar",
      "/qunar/priceVerifyQunar",
      "/qunar/orderQunar",
      "/qunar/paymentVerifyQunar",
      "/fz/platform/queryOrderList",
      "/fz/platform/queryRefundOrderList",
      "/fz/platform/queryChangeOrderList",
    ];
    // 检查是否是白名单URL
    const isNoAuthUrl = noAuthUrls.some((pattern) =>
      config.url.includes(pattern)
    );

    if (isNoAuthUrl) {
      return config;
    }

    // 对于需要认证的请求，添加CSRF token
    if (!csrfToken) {
      try {
        // 尝试从cookie获取
        const cookieToken = getCookie("csrftoken");
        if (cookieToken) {
          csrfToken = cookieToken;
          safeLog.info("CSRF Token found in cookie");
        } else {
          // 如果cookie中没有，再发起请求获取
          await fetchCsrfToken();
        }
      } catch (error) {
        safeLog.warn(
          "Failed to get CSRF token, request may fail",
          error.message
        );
        // 不抛出错误，让请求继续（可能会被后端拒绝）
      }
    }

    if (csrfToken) {
      config.headers["X-CSRFToken"] = csrfToken;
    }

    // 添加JWT token
    // 添加JWT token - 使用Bearer格式
    const jwtToken = window.sessionStorage.getItem("token");
    if (jwtToken) {
      // 检查是否已经是Bearer格式
      if (jwtToken.startsWith("Bearer ")) {
        config.headers["Authorization"] = jwtToken;
      } else {
        config.headers["Authorization"] = `Bearer ${jwtToken}`;
      }
    }

    // 开发环境打印请求日志（不包含敏感数据）
    if (process.env.NODE_ENV === "development") {
      safeLog.info("Request config:", {
        url: config.url,
        method: config.method,
        hasCsrfToken: !!config.headers["X-CSRFToken"],
        hasJwtToken: !!config.headers["Authorization"],
      });
    }

    return config;
  },
  function (error) {
    // 对请求错误做些什么
    safeLog.error("Request interceptor error:", error.message);
    return Promise.reject(error);
  }
);

// 添加响应拦截器
httpService.interceptors.response.use(
  function (response) {
    // 如果响应中有新的CSRF token，更新
    if (response.data && response.data.csrfToken) {
      csrfToken = response.data.csrfToken;
      // 同时存储到localStorage和cookie
      localStorage.setItem("csrf_token", csrfToken);
      document.cookie = `csrftoken=${csrfToken}; path=/`;
      if (response.config.url === "/user/login") {
        safeLog.info("CSRF Token updated from login response");
      } else {
        safeLog.info("CSRF Token updated from response");
      }
    }
    if (process.env.NODE_ENV === "development") {
      safeLog.info("Response success:", {
        url: response.config.url,
        status: response.status,
        dataKeys: Object.keys(response.data || {}),
      });
    }
    return response;
  },
  async function (error) {
    const originalRequest = error.config;

    // 处理CSRF token失效（403错误）
    if (error.response?.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;
      safeLog.warn("CSRF token可能失效，尝试重新获取");

      try {
        // 清除旧的token
        csrfToken = null;
        // 重新获取CSRF token
        await fetchCsrfToken();
        // 更新请求头并重试
        originalRequest.headers["X-CSRFToken"] = csrfToken;
        return httpService(originalRequest);
      } catch (refreshError) {
        safeLog.error("Failed to refresh CSRF token:", refreshError);
        // 如果是登录页面，跳转到登录
        if (!window.location.pathname.includes("/login")) {
          window.location.href = "/login";
        }
      }
    }

    // 处理401未授权
    if (error.response?.status === 401) {
      safeLog.warn("Unauthorized, clearing tokens");
      clearAuthTokens();
      // 检查当前是否已经在登录页面（考虑前后端路径差异）
      const isOnLoginPage =
        window.location.pathname === "/login" ||
        window.location.pathname.includes("login") ||
        error.config?.url.includes("/user/login");
      if (!isOnLoginPage) {
        setTimeout(() => {
          window.location.href = "/login";
        }, 1000);
      }
    }

    return Promise.reject(error);
  }
);

// 添加URL白名单检查函数
export const isNoAuthUrl = (url) => {
  const noAuthUrls = [
    "/user/login",
    "/user/captcha",
    "/user/getCsrfToken/",
    "/tc/SearchZZXQTC",
    "/tc/VerifyZZXQTC",
    "/tc/OrderZZXQTC",
    "/fz/queryTaobao",
    "/fz/priceVerifyTaobao",
    "/fz/orderTaobao",
    "/fz/orderCancelTaobao",
    "/fz/order",
    "/fz/paymentVerifyTaobao",
    "/productManagement/recordFlightChangeNotification",
    "/qunar/queryQunar",
    "/qunar/priceVerifyQunar",
    "/qunar/orderQunar",
    "/qunar/paymentVerifyQunar",
    "/fz/platform/queryOrderList",
    "/fz/platform/queryRefundOrderList",
    "/fz/platform/queryChangeOrderList",
  ];

  return noAuthUrls.some((pattern) => url.includes(pattern));
};

// 添加清除token的函数
export const clearAuthTokens = () => {
  csrfToken = null;
  sessionStorage.removeItem("token");
  safeLog.info("Auth tokens cleared");
};

/*网络请求部分*/

// 获取请求配置
function getRequestConfig(url, method, data = {}, params = {}) {
  const validMethods = ["get", "post", "put", "delete", "patch"];

  // 检查请求方法是否合法
  if (!validMethods.includes(method.toLowerCase())) {
    throw new Error(`Invalid HTTP method: ${method}`);
  }

  // 如果是 GET 请求且传入了 data，抛出错误
  if (method.toLowerCase() === "get" && Object.keys(data).length > 0) {
    throw new Error(
      "GET requests do not support request body. Please use `params` instead."
    );
  }

  const config = {
    url: url,
    method: method,
  };

  // 根据请求方法设置 data 和 params
  if (method.toLowerCase() === "get") {
    config.params = params; // GET 请求只使用 params
  } else {
    config.data = data; // 其他请求使用 data
    config.params = params; // 其他请求也可以使用 params
  }
  // 移除console.log，改用安全日志
  safeLog.info("Request config created", { url, method });
  return config;
}

// 封装通用请求函数
export function request(url, method = "get", data = {}, params = {}) {
  const config = getRequestConfig(url, method, data, params);

  return httpService(config)
    .then((response) => {
      if (process.env.NODE_ENV === "development") {
        console.log(
          `${method.toUpperCase()} Request Success:`,
          url,
          data,
          params
        );
      }
      return response;
    })
    .catch((error) => {
      if (process.env.NODE_ENV === "development") {
        console.error(
          `${method.toUpperCase()} Request Error:`,
          url,
          data,
          params,
          error
        );
      }
      throw error;
    });
}

/**
 * 文件上传函数
 * @param {string} url - 请求的 URL
 * @param {FormData} params - 文件数据（FormData 对象）
 * @returns {Promise} - 返回一个 Promise 对象
 */
export function fileUpload(url, params = {}) {
  // 检查参数是否为 FormData 类型
  if (!(params instanceof FormData)) {
    throw new Error("File upload requires FormData as the params.");
  }

  return httpService({
    url: url,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "multipart/form-data", // 设置请求头为 multipart/form-data
    },
  })
    .then((response) => {
      if (process.env.NODE_ENV === "development") {
        console.log("File Upload Success:", url, response);
      }
      return response; // 直接返回响应数据
    })
    .catch((error) => {
      if (process.env.NODE_ENV === "development") {
        console.error("File Upload Error:", url, error);
      }
      throw error; // 抛出错误，由调用方处理
    });
}

export function getServerUrl() {
  return getCurrentBaseUrl();
}

const get = (url, params = {}) => request(url, "get", {}, params);
const post = (url, data = {}) => request(url, "post", data);
const put = (url, data = {}) => request(url, "put", data);
const del = (url, params = {}) => request(url, "delete", {}, params);

export default {
  get,
  post,
  put,
  del,
  fileUpload,
  getServerUrl,
  fetchCsrfToken,
  isNoAuthUrl, // 新增
  clearAuthTokens, // 新增
  // 同时导出axios实例以便特殊使用
  instance: httpService,
  getCookie,
};
/* eslint-enable */
